export enum LocationType {
  LocationTypeUndefined = "",
  LocationTypeInside = "INSIDE",
  LocationTypeOutside = "OUTSIDE",
}
